import React, { useEffect } from 'react'
import { X } from 'lucide-react'

interface DrawerProps {
 isOpen: boolean
 onClose: () => void
 title: string
 children: React.ReactNode
 size?: 'sm' | 'md' | 'lg' | 'xl'
}

export const Drawer: React.FC<DrawerProps> = ({
 isOpen,
 onClose,
 title,
 children,
 size = 'md'
}) => {
 useEffect(() => {
 if (isOpen) {
 document.body.style.overflow = 'hidden'
 } else {
 document.body.style.overflow = 'unset'
 }

 return () => {
 document.body.style.overflow = 'unset'
 }
 }, [isOpen])

 if (!isOpen) return null

 const getSizeClass = () => {
 switch (size) {
 case 'sm': return 'max-w-sm'
 case 'md': return 'max-w-md'
 case 'lg': return 'max-w-lg'
 case 'xl': return 'max-w-xl'
 default: return 'max-w-md'
 }
 }

 return (
 <>
 {/* Overlay */}
 <div
 className="fixed inset-0 bg-black/50 z-40 animate-in fade-in duration-200"
 onClick={onClose}
 />

 {/* Drawer */}
 <div
 className={`fixed top-0 right-0 h-full ${getSizeClass()} w-full bg-card shadow-2xl z-50 animate-in slide-in-from-right duration-300`}
 >
 {/* Header */}
 <div className="flex items-center justify-between px-6 py-4 border-b border-border">
 <h2 className="text-lg font-semibold text-foreground">
 {title}
 </h2>
 <button
 onClick={onClose}
 className="p-2 text-muted-foreground hover:text-muted-foreground dark:hover:text-gray-300 rounded-lg hover:bg-surface transition-colors"
 >
 <X className="h-5 w-5" />
 </button>
 </div>

 {/* Content */}
 <div className="overflow-y-auto h-[calc(100%-73px)]">
 {children}
 </div>
 </div>
 </>
 )
}

